interface FirstTimeDate {
  day: number;
  month: number;
  year: number;
}

interface Count {
  count: number;
  first_time_date: FirstTimeDate;
  day: number;
  month: number;
  year: number;
  has_showed: string; // Pode ser 'true' ou 'false', mas está definido como string
  last_page: string;
}

interface EmailSubmission {
  campaignId: number;
  email: string;
  submittedAt: string;
}

export const subscribeExitStore = defineStore("susbcribeExit", {
  state: () => ({
    bellaSubscribeExit: {} as Count,
    lastEmailSubmission: null as EmailSubmission | null,
  }),
  actions: {
    async setSubscribeParams(payload: Count) {
      this.bellaSubscribeExit = payload;
    },
    markEmailSubmitted(campaignId: number, email: string) {
      this.lastEmailSubmission = {
        campaignId,
        email,
        submittedAt: new Date().toISOString(),
      };
    },
    hasSubmittedForCampaign(campaignId: number) {
      return (
        this.lastEmailSubmission !== null &&
        this.lastEmailSubmission.campaignId === campaignId
      );
    },
  },
  persist: {
    key: "bellaSubscribeExit",
    storage: piniaPluginPersistedstate.localStorage(),
  },
});
